import ReactPlayer from "react-player";
import { useEffect } from "react";
import { applyPlaybackRate } from "../utils/applyPlayerOverrides";

/**
 * Keeps the underlying media element's playback rate in sync with
 * `playbackRate` once the player is ready, re-applying after source resets.
 */
export default function useApplyPlaybackRate(
  player: ReactPlayer | undefined,
  canPlay: boolean,
  playbackRate: number,
  playerKey: string,
) {
  useEffect(() => {
    if (player && canPlay) {
      applyPlaybackRate(player, playbackRate);
    }
  }, [player, canPlay, playbackRate, playerKey]);
}
